import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=041cf828"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041cf828')) {
      api.createRecord('041cf828', component.options)
    } else {
      api.reload('041cf828', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=041cf828", function () {
      api.rerender('041cf828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/sideBar/logo.vue"
export default component.exports